<div class="three-dots-blinking">
    <span></span>
</div>
